export const set_accion = (state, value) => {
    state.accion = value
}

export const set_ruex_solicitud = (state, value) => {
    state.id_ruex_solicitud = value
}